import React, { ReactNode, MouseEvent } from 'react';
import { Link } from 'react-router-dom';
import './buttons.scss';

interface ButtonProps {
  action?: (arg: any) => void;
  disabled?: boolean;
  id?: string;
  children: ReactNode;
  className?: string;
  link?: string;
  openLinkInSameTab?: boolean;
  type?: 'submit' | 'reset' | 'button';
  isExternalUrl?: boolean;
}

export default function Button({
  id,
  action,
  children,
  disabled,
  className,
  link,
  openLinkInSameTab = false,
  type,
  isExternalUrl = false,
}: ButtonProps): React.ReactElement {
  const onClick = (e: MouseEvent): void => {
    if (!action) return;
    e.preventDefault();
    action(e);
  };

  const linkProps = {
    className: disabled ? 'disabled' : '',
    rel: openLinkInSameTab ? '' : 'noopener noreferrer',
    target: openLinkInSameTab ? '' : '_blank',
  };

  const renderLink = (): React.ReactElement => {
    if (!link) return <></>;
    return isExternalUrl ? (
      <a href={link} {...linkProps}>
        {children}
      </a>
    ) : (
      <Link to={link} {...linkProps}>
        {children}
      </Link>
    );
  };

  return (
    <div className={`button ${className ?? ''}`} onClick={onClick}>
      {link ? (
        renderLink()
      ) : (
        <button type={type} id={id} disabled={disabled}>
          {children}
        </button>
      )}
    </div>
  );
}
